export class Select {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.ogSelect = this.root.querySelector('select');
        this.ogSelectName = this.ogSelect.getAttribute('name');
        this.isMobileRadio = this.root.getAttribute('data-is-mobile-radio');
        this.radios = this.isMobileRadio
            ? this.root.querySelectorAll(`input[name='${this.ogSelectName}']`)
            : null;

        this.elementClass = 'form-select';
        this.selectData = [];
        this.selectedOptionValue = null;

        this.activeOptionValue = null;
        this.activeOptionKey = null;
        this.activeOptionText = null;

        this.customSelectElement = null;
        this.activeBoxElement = null;

        this.customSelectEvent = null;

        this.isSearch = this.root.classList.contains('-with-search');
        this.searchValue = '';

        return true;
    }

    init() {
        this.storeSelectData();
        this.createElement();
        this.activeBoxHandle();
        this.handleOptionClickEvent();
        this.handleOgSelectEvent();

        if (this.isMobileRadio) {
            this.handleRadioChange();
            this.handleSelectChange();
            this.handleSelectView();
            window.addEventListener('resize', this.handleSelectView.bind(this));
        }

        if (this.selectedOptionValue) this.handleSelectedOptionClick();
    }

    storeSelectData() {
        const options = this.root.querySelectorAll('option');
        if (options.length === 0) return;

        options.forEach((option, key) => {
            const { value, disabled, textContent, innerHTML } = option;
            if (option.selected) this.selectedOptionValue = value;
            const optionObject = {};
            optionObject.value = value || '';
            optionObject.textContent = textContent || '';
            optionObject.disabled = disabled;

            this.selectData.push(optionObject);

            if (key === 0) {
                this.activeOptionKey = key;
                this.activeOptionValue = value;
                this.activeOptionText = innerHTML;
            }
        });
    }

    createElement() {
        this.customSelectElement = document.createElement('div');
        this.customSelectElement.classList.add(
            `${this.elementClass}__wrapper`,
            'p-relative'
        );

        this.activeBoxElement = document.createElement('div');
        this.activeBoxElement.classList.add(
            `${this.elementClass}__active-box`,
            'fields-texts'
        );

        this.activeBoxElement.setAttribute('tabindex', 0);

        this.activeBoxElement.innerHTML = this.activeOptionText;

        this.customSelectElement.appendChild(this.activeBoxElement);

        const optionsWrapper = document.createElement(`div`);
        optionsWrapper.classList.add(
            `${this.elementClass}__options-wrapper`,
            'p-absolute'
        );
        this.customSelectElement.appendChild(optionsWrapper);

        this.createDropdownOptions(this.selectData);

        this.root.appendChild(this.customSelectElement);

        this.root.classList.add('initialized');
    }

    createDropdownOptions(data) {
        const optionsWrapper = this.customSelectElement.querySelector(
            `.${this.elementClass}__options-wrapper`
        );

        optionsWrapper.textContent = '';
        let searchInput = null;
        if (this.isSearch) {
            searchInput = document.createElement('input');
            searchInput.setAttribute('type', 'search');
            searchInput.classList.add(`${this.elementClass}__search`);
            searchInput.setAttribute('placeholder', 'Search');
            searchInput.value = this.searchValue;
            optionsWrapper.appendChild(searchInput);
            this.handleSearchInput(searchInput);
        }

        data.forEach(item => {
            const { value, textContent, disabled } = item;
            if (disabled || this.activeOptionValue === value) return;

            const option = document.createElement('div');
            option.classList.add(`${this.elementClass}__option`, 'p-small');
            option.textContent = textContent;
            option.setAttribute('data-value', value);

            optionsWrapper.appendChild(option);
        });

        if (searchInput) {
            this.handleSearchInputChange(searchInput);
        }
    }

    activeBoxHandle() {
        const activeBox = this.customSelectElement.querySelector(
            `.${this.elementClass}__active-box`
        );

        activeBox.addEventListener('click', () => {
            if (this.customSelectElement.classList.contains('expanded')) {
                this.hideSelect();
            } else {
                this.hideAllSelects();
                this.expandSelect();
            }
        });

        activeBox.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
                if (this.customSelectElement.classList.contains('expanded')) {
                    this.hideSelect();
                    this.handleOptionsTabIndex(false);
                } else {
                    this.hideAllSelects();
                    this.expandSelect();
                    this.handleOptionsTabIndex();
                }
            }
        });
    }

    handleSearchInput(searchInput) {
        searchInput.addEventListener('input', e => {
            this.handleSearchInputChange(e.target);
        });
    }

    handleSearchInputChange(target) {
        let { value } = target;
        this.searchValue = value;
        if (value.length > 0) {
            value = value.charAt(0).toUpperCase() + value.slice(1);
        }
        const options = this.customSelectElement.querySelectorAll(
            `.${this.elementClass}__option`
        );

        if (options.length > 0) {
            options.forEach(option => {
                const { textContent } = option;

                if (textContent.includes(value)) {
                    option.classList.remove('d-none');
                } else {
                    option.classList.add('d-none');
                }
            });
        }
    }

    handleOptionsTabIndex(isAdd = true) {
        const options = this.customSelectElement.querySelectorAll(
            `.${this.elementClass}__option`
        );
        if (options.length === 0) return;

        options.forEach(option => {
            option.setAttribute('tabindex', isAdd ? 0 : -1);
        });
    }

    handleOptionClickEvent() {
        if (!this.customSelectElement) return;

        const options = this.customSelectElement.querySelectorAll(
            `.${this.elementClass}__option`
        );
        if (options.length === 0) return;

        options.forEach(option => {
            const optionValue = option.getAttribute('data-value');
            const optionText = option.textContent;
            option.addEventListener('click', () =>
                this.handleOptionClick(optionValue, optionText)
            );
            option.addEventListener('keydown', e => {
                if (e.key === 'Enter') {
                    this.handleOptionClick(optionValue, optionText);
                }
            });
        });
    }

    handleOptionClick(optionValue, optionText) {
        this.hideSelect();
        this.activeBoxElement.textContent = optionText;
        this.ogSelect.value = optionValue;

        this.activeOptionText = optionText;
        this.activeOptionValue = optionValue;
        this.activeOptionKey = this.findObjectKeyFromDataArray(optionValue);

        this.ogSelect.value = optionValue;

        const filteredSelectData = this.selectData.filter(item => {
            if (!item.disabled && item.value !== optionValue) return item;
        });

        this.customSelectEvent = new CustomEvent('onSelectChange', {
            detail: {
                root: this.root,
                text: this.activeOptionText,
                value: this.activeOptionValue,
                name: this.ogSelect.getAttribute('name'),
            },
        });
        this.root.dispatchEvent(this.customSelectEvent);

        setTimeout(() => {
            this.createDropdownOptions(filteredSelectData);
            this.handleOptionClickEvent();
        }, 300);
    }

    handleOgSelectEvent() {
        this.ogSelect.addEventListener('change', e => {
            const { target } = e;
            const targetData =
                this.selectData[this.findObjectKeyFromDataArray(target.value)];
            this.handleOptionClick(targetData.value, targetData.textContent);
        });
    }

    findObjectKeyFromDataArray(value) {
        let indexToRetun = null;
        this.selectData.forEach((obj, index) => {
            if (obj.value === value) {
                indexToRetun = index;
            }
        });

        return indexToRetun;
    }

    expandSelect() {
        this.customSelectElement.classList.add('expanded');
        const expandEvent = new CustomEvent('onSelectOpen', {
            detail: {
                root: this.root,
                text: this.activeOptionText,
                value: this.activeOptionValue,
                name: this.ogSelect.getAttribute('name'),
            },
        });
    }

    hideSelect() {
        this.customSelectElement.classList.remove('expanded');
    }

    hideAllSelects() {
        const expandedSelects = document.querySelectorAll(
            '.form-select__wrapper.expanded'
        );

        if (expandedSelects.length > 0) {
            expandedSelects.forEach(select => {
                select.classList.remove('expanded');
            });
        }
    }

    handleSelectView() {
        if (window.innerWidth > 991.98) {
            this.customSelectElement.classList.remove('d-none');
        } else {
            this.customSelectElement.classList.add('d-none');
        }
    }

    handleSelectChange() {
        if (!this.radios || this.radios.length === 0) return;

        this.root.addEventListener('onSelectChange', e => {
            const { value } = e.detail;
            const radioToCheck = Array.from(this.radios).filter(
                item => item.value === value
            );
            if (
                radioToCheck &&
                radioToCheck.length > 0 &&
                !radioToCheck[0].checked
            )
                radioToCheck[0].checked = true;
        });
    }

    handleRadioChange() {
        if (!this.radios || this.radios.length === 0) return;

        this.radios.forEach(radio => {
            radio.addEventListener('change', e => {
                const { target } = e;
                const { value } = target;
                const text = target.parentElement.textContent;
                this.handleOptionClick(value, text);
            });
        });
    }

    handleSelectedOptionClick() {
        if (!this.customSelectElement) return;

        const options = this.customSelectElement.querySelectorAll(
            `.${this.elementClass}__option`
        );
        if (options.length === 0) return;

        options.forEach(option => {
            const optionValue = option.getAttribute('data-value');
            if (optionValue === this.selectedOptionValue) option.click();
        });
    }
}
